import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Operadores from './pages/Operadores';
import Postulaciones from './pages/Postulaciones';
import PostulacionPublica from './pages/PostulacionPublica';
import PostulacionCompletada from './pages/PostulacionCompletada';
import Documentos from './pages/Documentos';
import DocumentosOperador from './pages/DocumentosOperador';
import MapaOperadores from './pages/MapaOperadores';
import Remolques from './pages/Remolques';
import Vehiculos from './pages/Vehiculos';
import './App.css';

// Páginas placeholder para otros módulos
const Viajes = () => <div className="page-placeholder"><h2>🗺️ Viajes</h2><p>Módulo en desarrollo</p></div>;
const Novedades = () => <div className="page-placeholder"><h2>⚠️ Novedades</h2><p>Módulo en desarrollo</p></div>;
const Inspecciones = () => <div className="page-placeholder"><h2>🔍 Inspecciones</h2><p>Módulo en desarrollo</p></div>;
const Reportes = () => <div className="page-placeholder"><h2>📈 Reportes</h2><p>Módulo en desarrollo</p></div>;

const AppRoutes: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <div className="loading-screen">Cargando...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <Login /> : (user?.rol === 'operador' ? <Navigate to="/documentos" /> : <Navigate to="/dashboard" />)} />
      <Route path="/postulacion/:token" element={<PostulacionPublica />} />
      <Route path="/postulacion-completada" element={<PostulacionCompletada />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/operadores"
        element={
          <ProtectedRoute>
            <Layout>
              <Operadores />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/vehiculos"
        element={
          <ProtectedRoute>
            <Layout>
              <Vehiculos />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/remolques"
        element={
          <ProtectedRoute>
            <Layout>
              <Remolques />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/documentos"
        element={
          <ProtectedRoute>
            <Layout>
              {user?.rol === 'operador' ? <DocumentosOperador /> : <Documentos />}
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/viajes"
        element={
          <ProtectedRoute>
            <Layout>
              <Viajes />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/novedades"
        element={
          <ProtectedRoute>
            <Layout>
              <Novedades />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inspecciones"
        element={
          <ProtectedRoute>
            <Layout>
              <Inspecciones />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes"
        element={
          <ProtectedRoute>
            <Layout>
              <Reportes />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/postulaciones"
        element={
          <ProtectedRoute>
            <Layout>
              <Postulaciones />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mapa"
        element={
          <ProtectedRoute>
            <Layout>
              <MapaOperadores />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
};

export default App;
